import quoteApi from '../../../api/quote'
import * as types from './mutation-types.js'
import * as globalTypes from '../../mutation-types'
import wizardApi from '../../../api/wizard'

export const searchQuotesByDate = async ({ dispatch, commit }, dateRange) => {
    try {
      var result = await quoteApi.searchQuotesByDate(dateRange.startDate, dateRange.endDate);
      commit(types.GET_ALL_ADMIN, result.data);
    }
    catch (e) {
      let msg = "There was an error getting all quotes.";
      dispatch('showError', msg, { root: true })
      throw msg;
    }
  };

  export const saveAdminQuote = ({commit}, data) => {
    commit(globalTypes.LOADING_START)
    quoteApi.update(data)
    // Check child objs to see if data comes up
    .then(({status}) => {
      if(status === 200){
        let msg = {
          title: 'Saved.',
          message: 'Quote saved successfully.',
          type: 'success'
        }
        console.log('quote saved.')
        commit(types.SET_SELECTED_QUOTE_ADMIN, data)
        commit(globalTypes.NOTIFY_ERRORS, msg)
      }else{
        // show Error
        var error = {
          title: 'Error',
          message: 'Error',
          type: 'error'
        }
      commit(globalTypes.LOADED_SUCCESS)
      commit(globalTypes.NOTIFY_ERRORS, error)
      }
      commit(globalTypes.LOADED_SUCCESS)
    })
  }

  export const createAdminNewOffer = async ({ dispatch, commit, state, rootState }) => {
    try {
      var newOffer = { vehicleID: state.selectedAdminQuote.vehicles[0].vehicleID, zipCode: state.selectedAdminQuote.quotePickupLocation.zipCode, userID: rootState.login.userID };
      var result = await wizardApi.createNewOffer(newOffer)
      commit(types.SET_ADMIN_SUGGESTED_OFFER, result.data)
    }
    catch (e) {
      let msg = "There was an error creating Admin New Offer.";
      dispatch('showError', msg, { root: true });
      throw msg;
    }
  }

  export const updateAdminOffer = async({commit},data) => {
    await quoteApi.updateAdminOffer(data)    
  }


// WEBPACK FOOTER //
// ./src/store/modules/quotes/actions.js